import { render } from "./ServerMapping.vue?vue&type=template&id=e8e5fdc2&scoped=true"
import script from "./ServerMapping.vue?vue&type=script&lang=js"
export * from "./ServerMapping.vue?vue&type=script&lang=js"

import "./ServerMapping.vue?vue&type=style&index=0&id=e8e5fdc2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e5fdc2"]])

export default __exports__